/*
  Tooltip manager for product color swatches.
  Creates a single tooltip element and reuses it for all swatches.
*/
(function () {
  // Create tooltip element
  var tooltip = document.createElement("div");
  tooltip.className = "swatch-tooltip";
  tooltip.setAttribute("role", "status");
  tooltip.setAttribute("aria-hidden", "true");
  document.body.appendChild(tooltip);

  var hideTimer = null;

  // Show tooltip for target button
  function showTooltip(target) {
    clearTimeout(hideTimer);
    var label = target.getAttribute("aria-label") || target.dataset.label || "";
    if (!label) return;

    tooltip.textContent = label;
    tooltip.classList.remove("swatch-tooltip--below");
    tooltip.classList.add("visible");
    tooltip.setAttribute("aria-hidden", "false");

    // make sure tooltip is visible to measure it
    tooltip.style.display = "block";
    tooltip.style.opacity = "0";

    requestAnimationFrame(function () {
      var rect = target.getBoundingClientRect();
      var ttRect = tooltip.getBoundingClientRect();

      // preferred position: above the swatch
      var top = rect.top + window.scrollY - ttRect.height - 10;
      var left = rect.left + window.scrollX + rect.width / 2 - ttRect.width / 2;

      // if there's not enough space above, place below
      if (top < window.scrollY + 6) {
        top = rect.bottom + window.scrollY + 10;
        tooltip.classList.add("swatch-tooltip--below");
      }

      // clamp horizontally within viewport
      var minLeft = window.scrollX + 6;
      var maxLeft =
        window.scrollX +
        document.documentElement.clientWidth -
        ttRect.width -
        6;
      if (left < minLeft) left = minLeft;
      if (left > maxLeft) left = maxLeft;

      tooltip.style.left = left + "px";
      tooltip.style.top = top + "px";
      // final show
      requestAnimationFrame(function () {
        tooltip.style.opacity = "1";
      });
    });
  }

  // Hide tooltip
  function hideTooltipSoon() {
    clearTimeout(hideTimer);
    tooltip.style.opacity = "0";
    tooltip.setAttribute("aria-hidden", "true");
    hideTimer = setTimeout(function () {
      tooltip.style.display = "none";
      tooltip.classList.remove("visible", "swatch-tooltip--below");
    }, 160);
  }

  // Event delegation: mouseover/mouseout (works for dynamic elements)
  document.addEventListener("mouseover", function (e) {
    var btn = e.target.closest && e.target.closest(".swatch-tooltip-anchor");
    if (btn) showTooltip(btn);
  });

  document.addEventListener("mouseout", function (e) {
    var btn = e.target.closest && e.target.closest(".swatch-tooltip-anchor");
    if (!btn) return;
    var related = e.relatedTarget;
    // if mouse moved to an element inside the same button, do nothing
    if (related && btn.contains(related)) return;
    hideTooltipSoon();
  });

  // keyboard accessibility: show on focus, hide on blur
  document.addEventListener("focusin", function (e) {
    var btn = e.target.closest && e.target.closest(".swatch-tooltip-anchor");
    if (btn) showTooltip(btn);
  });
  document.addEventListener("focusout", function (e) {
    var btn = e.target.closest && e.target.closest(".swatch-tooltip-anchor");
    if (btn) hideTooltipSoon();
  });

  // touch: tap on swatch shows tooltip for short time; tapping elsewhere hides it
  document.addEventListener(
    "touchstart",
    function (e) {
      var btn = e.target.closest && e.target.closest(".swatch-tooltip-anchor");
      if (btn) {
        showTooltip(btn);
        clearTimeout(hideTimer);
        hideTimer = setTimeout(hideTooltipSoon, 2200);
      } else {
        hideTooltipSoon();
      }
    },
    { passive: true }
  );
})();
